import React, { useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsExporting from "highcharts/modules/exporting";
import HighchartsAccessibility from "highcharts/modules/accessibility";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../../theme/appStyles";
import { useGetAllPurDhashOrderListSatausQuery } from "../../../Api/attoDeskApi";
import { CircularProgress } from "@mui/material";

const convertStatus = (unit: string): string => {
  switch (unit) {
    case "OrderListCreated":
      return "Draft";
    case "SentToManager":
      return "Pending Approval";
    case "ManagerApproved":
      return "Approved";
    case "UpdatedPrice":
      return "Updated Price";
    case "UpdatedStoreOnly":
      return "Updated Store";
    case "Processed":
      return "Processed";
    case "Completed":
      return "Completed";
    case "Rejected":
      return "Rejected";
    case "ReceiptUpdated":
      return "Receipt Updated";
    default:
      return unit;
  }
};

export const OrderListStatusOrder = [
  "OrderListCreated",
  "SentToManager",
  "ManagerApproved",
  "UpdatedPrice",
  // "UpdatedStoreOnly",
  "Processed",
  "Completed",
  "ReceiptUpdated",
  "Rejected",
] as const;

HighchartsExporting(Highcharts);
HighchartsAccessibility(Highcharts);

const PayrollDashboard = () => {
  const classes = useStyles();
  const theme = useTheme();

  const { data: orderListStatusData, isLoading: orderListStatusLoading } =
    useGetAllPurDhashOrderListSatausQuery({
      id: "",
    });

  const statusData = orderListStatusData?.data;

  const data = OrderListStatusOrder.map((status) => statusData?.[status] ?? 0);
  const categories = useMemo(() => OrderListStatusOrder.map(convertStatus), []);

  const barChartOptions: Highcharts.Options = useMemo(
    () => ({
      chart: {
        type: "column",
        backgroundColor: theme.palette.cardAdd?.bgColor || "#fff",
      },
      title: { text: undefined },
      xAxis: {
        categories,
        title: {
          text: "Status",
          style: {
            color: theme.palette.heading?.headingColor || "#000",
            fontSize: "0.75rem",
          },
        },
        labels: {
          style: {
            color: theme.palette.heading?.headingColor || "#000",
            fontSize: "0.75rem",
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: "Number of Orders",
          style: {
            color: theme.palette.heading?.headingColor || "#000",
            fontSize: "0.75rem",
          },
        },
        labels: {
          style: {
            color: theme.palette.heading?.headingColor || "#000",
          },
        },
      },
      tooltip: {
        pointFormat: "<b>{point.y} Orders</b>",
      },
      plotOptions: {
        column: {
          // use column here instead of bar
          dataLabels: {
            enabled: true,
            style: {
              color: theme.palette.heading?.headingColor || "#000",
              fontSize: "0.75rem",
            },
          },
        },
      },
      legend: { enabled: false },
      series: [
        {
          type: "column",
          name: "Orders",
          data,
          color: theme.palette.primary.main,
        },
      ],
      credits: { enabled: false },
      responsive: {
        rules: [
          {
            condition: { maxWidth: 600 },
            chartOptions: {
              chart: { height: 400 },
              xAxis: { labels: { style: { fontSize: "0.6rem" } } },
            },
          },
        ],
      },
    }),
    [categories, data, theme]
  );

  return (
    <div
      style={{
        padding: "5px",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {orderListStatusLoading ? (
        <div
          style={{
            display: "flex",
            width: "100%",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <HighchartsReact highcharts={Highcharts} options={barChartOptions} />
      )}
    </div>
  );
};

export default PayrollDashboard;
